import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ForgotPassword.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState<{ message: string; reset_url: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.match(/^[^@]+@[^@]+\.[^@]+$/)) {
      setError('Wpisz prawidłowy adres email');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const r = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await r.json();
      if (!r.ok) { setError(data.detail || 'Błąd'); return; }
      setResult(data);
    } catch {
      setError('Błąd połączenia. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-page">
      <div className="fp-card">
        <div className="fp-logo">
          <span className="logo-10">10</span><span className="logo-drive">drive</span>
          <span className="logo-moto">moto</span>
        </div>
        <h2>Resetowanie hasła</h2>

        {result ? (
          <div className="fp-success">
            <div className="fp-icon">✓</div>
            <p>{result.message}</p>
            {result.reset_url && (
              <div className="fp-dev-link">
                <p className="fp-dev-label">Link (tryb testowy):</p>
                <a href={result.reset_url} className="fp-reset-link">{result.reset_url}</a>
              </div>
            )}
            <Link to="/login" className="fp-btn">Wróć do logowania</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="fp-form">
            <p className="fp-hint">Wpisz adres email swojego konta. Wyślemy link do resetowania hasła.</p>
            <div className="fp-field">
              <label>Email</label>
              <input
                type="email" autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="jan@example.com"
                className={error ? 'error' : ''}
              />
              {error && <span className="fp-error">{error}</span>}
            </div>
            <button type="submit" className="fp-btn" disabled={loading}>
              {loading ? 'Wysyłanie...' : 'Wyślij link resetowania'}
            </button>
            <Link to="/login" className="fp-link-back">← Wróć do logowania</Link>
          </form>
        )}
      </div>
    </div>
  );
}
